// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1hPZr","selects":"Documents_selects__1CV0U"};